var map = {
	"./2gis.webp": 90577,
	"./close.png": 905,
	"./coin.webp": 76835,
	"./god.webp": 23452,
	"./heart.webp": 66194,
	"./like.webp": 66805,
	"./location.webp": 17365,
	"./phone.webp": 29854,
	"./smile.webp": 57650,
	"./smile2.webp": 45548,
	"./star.webp": 47838,
	"./telegram.webp": 23465,
	"./whatsapp.webp": 99704
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59945;